import * as angular from "angular";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";

export class ThreePLAlertsService {

  /* @ngInject */
  constructor(private bringozToastService: BringozToastService) {
  }

  // VOUCHER_CREATE //
  trainVoucherCreateSuccess(enableView?) {
    const message = {
      body: 'THREEPL_TRAIN_VOUCHER_CREATE_SUCCESS'
    };
    const view = enableView ? 'View' : null;
    return this.bringozToastService.success(message, undefined, view)
  }

}

angular
  .module('bringoz.admin.threePL')
  .service('threePLAlertsService', ThreePLAlertsService);
